import vSelect from "vue-select";
import firebase from "firebase/app";
import "firebase/storage";
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";
import ManageErrorMessages from "@/models/ManageErrorMessages.js";
import UploadVisitPointList from "@/components/optimization/upload-file/UploadVisitPointList.vue";
import UploadVehicleList from "@/components/optimization/upload-file/UploadVehicleList.vue";
import {downloadJobUploadTemplate} from "@/helpers/jobUploadTemplate.js";

export const uploadFileFormOptimization = {
	components: {
		vSelect,
		UploadVisitPointList,
		UploadVehicleList,
	},
	props: {
		inputFileId: {
			type: String,
			default: "fileOptimization",
		},
		inputFileIcon: {
			type: String,
			default: "TruckIcon",
		},
		activateListUploadFile: {
			type: Boolean,
			default: true,
		},
		typeUploadFile: {
			type: String,
			default: "VISIT_POINT_UPLOAD",
		},
		typeAction: {
			type: String,
			default: "UPLOAD",
		},
	},
	data() {
		return {
			storageRef: firebase.storage(),
			firebasePath: null,
			percent: 0,
			uploadProgress: 0,
			fileName: "",
			textStatus: "",
			progressColor: "success",
			activeAlertText: true,
			isDragging: false,
			maximize: false,
			status: null,
			dataFile: null,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			selectedCountry: null,
			is_indeterminate: false,
			capacityNamesAlert: true,
			activeDiscardedItemsPrompt: false,
			discardedItemsList: [],
			discardedItemsPerPage: 20,
			currentDiscardedItemsPage: 1,
			firesbaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
			// Enhanced UX properties
			showProgressOverlay: false,
			uploadCancelled: false,
			progressInterval: null,
			showSuccessState: false,
			showRedirectingState: false,
			uploadStartTime: null,
		};
	},
	computed: {
		enableUploadBtn() {
			return !this.dataFile;
		},
		uploadStatus() {
			if (this.textStatus === "success") return "text-success";
			else if (this.textStatus === "error") return "text-danger";
			else return "";
		},
		fileSize() {
			const fileBytes = this.dataFile.size;
			if (fileBytes >= 1073741824) {
				return (fileBytes / 1073741824).toFixed(2) + " GB";
			} else if (fileBytes >= 1048576) {
				return (fileBytes / 1048576).toFixed(2) + " MB";
			} else if (fileBytes >= 1024) {
				return (fileBytes / 1024).toFixed(2) + " KB";
			} else if (fileBytes > 1) {
				return fileBytes + " bytes";
			} else if (fileBytes == 1) {
				return fileBytes + " byte";
			} else {
				return "0 bytes";
			}
		},
		progressPercent: {
			get() {
				return this.uploadProgress;
			},
			set(value) {
				this.uploadProgress = value;
			},
		},
		fieldTypes() {
			return [
				{
					label: `xlsx`,
					icon: "arrow_right",
				},
				{
					label: `csv`,
					icon: "arrow_right",
				},
				{
					label: `json`,
					icon: "arrow_right",
				},
				{
					label: `xml`,
					icon: "arrow_right",
				},
				{
					label: `txt`,
					icon: "arrow_right",
				},
			];
		},
		getCheckedVisitPointsPickupUploadFile() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup;
		},
		getCheckedVisitPointsDeliveryUploadFile() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery;
		},
		getCheckedVehicleUploadFile() {
			return this.$store.state.vehicle.checkedUploadFiles === undefined ||
				this.$store.state.vehicle.checkedUploadFiles === "" ||
				this.$store.state.vehicle.checkedUploadFiles === null
				? []
				: this.$store.state.vehicle.checkedUploadFiles;
		},
		getCheckedJobsUploadFile() {
			return this.$store.state.moduleOptimization.checkedUploadFilesJobs === undefined ||
				this.$store.state.moduleOptimization.checkedUploadFilesJobs === "" ||
				this.$store.state.moduleOptimization.checkedUploadFilesJobs === null
				? []
				: this.$store.state.moduleOptimization.checkedUploadFilesJobs;
		},
		getJobsUploadFileList() {
			return this.$store.state.moduleOptimization.uploadFileListJobs === undefined ||
				this.$store.state.moduleOptimization.uploadFileListJobs === "" ||
				this.$store.state.moduleOptimization.uploadFileListJobs === null
				? []
				: this.$store.state.moduleOptimization.uploadFileListJobs;
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		isDisabledButton() {
			let result;
			if (this.typeUploadFile === "VISIT_POINT_UPLOAD") {
				if (
					this.getCheckedVisitPointsPickupUploadFile.length > 0 ||
					this.getCheckedVisitPointsDeliveryUploadFile.length > 0
				) {
					result = false;
				} else {
					result = true;
				}
			} else if (this.typeUploadFile === "VEHICLE_UPLOAD" && this.getCheckedVehicleUploadFile.length > 0) {
				result = false;
			} else if (this.typeUploadFile === "JOB_UPLOAD" && this.getJobsUploadFileList.length > 0) {
				result = false;
			} else {
				result = true;
			}
			return result;
		},
		// Pagination computed properties for discarded items
		paginatedDiscardedItems() {
			const startIndex = (this.currentDiscardedItemsPage - 1) * this.discardedItemsPerPage;
			const endIndex = startIndex + this.discardedItemsPerPage;
			return this.discardedItemsList.slice(startIndex, endIndex);
		},
		totalDiscardedItemsPages() {
			return Math.ceil(this.discardedItemsList.length / this.discardedItemsPerPage);
		},
		showDiscardedItemsPagination() {
			return this.discardedItemsList.length > this.discardedItemsPerPage;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		handleUpload() {
			if (this.uploadCancelled) return;

			const uploadTypeObject = {
				VISIT_POINT_UPLOAD: "/uploads/visit_point/",
				VEHICLE_UPLOAD: "/uploads/vehicle/",
				JOB_UPLOAD: "/uploads/visit_point/",
			};
			this.firebasePath = uploadTypeObject[this.typeUploadFile] || null;

			// Show progress overlay and record start time
			this.showProgressOverlay = true;
			this.progressPercent = 0;
			this.is_indeterminate = false;
			this.uploadStartTime = Date.now();

			// Start progress simulation
			this.startProgressSimulation();

			this.uploadOtherFile();
		},
		startProgressSimulation() {
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
			}

			const secureRandom = () => {
				const array = new Uint32Array(1);
				window.crypto.getRandomValues(array);
				return array[0] / (0xffffffff + 1);
			};

			const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3); // Curva suave

			let currentProgress = 0;
			const targetProgress = 98; // No pasar de 98%
			const duration = 8000; // Duración total estimada en ms
			const startTime = performance.now();

			this.progressInterval = setInterval(() => {
				if (this.uploadCancelled) {
					clearInterval(this.progressInterval);
					return;
				}

				const elapsed = performance.now() - startTime;
				let t = elapsed / duration;

				// Limitar t entre 0 y 1
				if (t > 1) t = 1;

				// Aplicar curva easeOutCubic
				currentProgress = targetProgress * easeOutCubic(t);

				// Añadir pequeñas variaciones aleatorias seguras
				currentProgress += secureRandom() * 0.3;

				// Evitar pasar de targetProgress
				if (currentProgress > targetProgress) {
					currentProgress = targetProgress;
				}

				this.progressPercent = Math.floor(currentProgress);
			}, 80); // Intervalo fijo para suavidad
		},
		completeProgress() {
			// Clear simulation interval
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
			}

			// Ensure minimum time for user to see progress
			const currentTime = Date.now();
			const uploadStartTime = this.uploadStartTime || currentTime;
			const elapsedTime = currentTime - uploadStartTime;
			const minimumDisplayTime = 3000; // 3 seconds minimum

			if (elapsedTime < minimumDisplayTime) {
				// If upload was too fast, continue the animation to minimum time
				const remainingTime = minimumDisplayTime - elapsedTime;
				const targetProgress = this.progressPercent || 0;

				// Animate from current progress to 100% over remaining time
				this.animateToCompletion(targetProgress, remainingTime);
			} else {
				// Upload took enough time, complete immediately
				this.finishProgressSequence();
			}
		},

		animateToCompletion(startProgress, duration) {
			const increment = (100 - startProgress) / (duration / 50); // Update every 50ms
			let currentProgress = startProgress;

			const animationInterval = setInterval(() => {
				currentProgress += increment;
				if (currentProgress >= 100) {
					currentProgress = 100;
					this.progressPercent = 100;
					clearInterval(animationInterval);
					this.finishProgressSequence();
				} else {
					this.progressPercent = Math.floor(currentProgress);
				}
			}, 50);
		},

		finishProgressSequence() {
			// Complete the progress
			this.progressPercent = 100;

			// Show success state after reaching 100%
			setTimeout(() => {
				this.showSuccessState = true;
			}, 300);

			// Show redirecting message after success state
			setTimeout(() => {
				this.showRedirectingState = true;
			}, 2000); // 2 seconds after success

			// Hide overlay and continue after showing redirecting message
			setTimeout(() => {
				this.successUpload();
			}, 3500); // 3.5 seconds total to show both messages
		},

		successUpload() {
			// Reset all states and hide progress overlay
			this.showSuccessState = false;
			this.showRedirectingState = false;
			this.showProgressOverlay = false;
			// Clean data and emit transition after the complete sequence
			this.cleanData();
			this.$emit("uploadStatusEmit", true);
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.$emit("dataFileEmit", this.dataFile);
			this.fileName = this.dataFile.name;
			this.percent = 0;
			this.textStatus = "success";
			this.progressColor = "success";
			this.uploadCancelled = false;

			// Auto-start upload after file selection
			this.$nextTick(() => {
				this.handleUpload();
			});
		},
		/**
		 * Subir arcchivos de tipologias VISIT_POINT, VEHICLE
		 */
		uploadOtherFile() {
			const fileExt = this.dataFile.name.split(".").pop();
			if (!this.dataFile) {
				return;
			}
			let filterFormat = this.fieldTypes.filter((format) => format.label === fileExt);
			if (filterFormat.length <= 0) {
				this.$vs.notify({
					time: 9000,
					title: this.$t("UploadFiles.InvalidFormatFile"),
					text:
						this.$t("UploadFiles.LoadMassiveAssignmentUploadFileError") +
						" " +
						this.$t("Upload") +
						" .xlsx, .csv, .json, .xml, .txt",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			} else {
				uploadFileToFirebase
					.call(this, this.dataFile, this.firebasePath)
					.then((res) => {
						Object.assign(this.firesbaseResponse, res);
						const payload = {
							bucket_path: this.firesbaseResponse.bucketPath,
							rows_number: 100,
						};
						return this.$store.dispatch("uploadFile/saveUploadFileTemporal", payload).then((res) => {
							if (Object.entries(res).length > 0) {
								this.percent = 100;
								// Complete the progress simulation and handle transition
								this.completeProgress();
							}
							return res;
						});
					})
					.catch((error) => {
						this.textStatus = "error";
						this.progressColor = "danger";
						if (Object.hasOwnProperty.call(error, "code")) {
							this.manageErrorMessages.setErrorMessage(error.code);
						}
						if (Object.hasOwnProperty.call(error, "data")) {
							this.status = false;
						}
						this.manageErrorMessages.showMessage();
					});
			}
		},
		cancelUpload() {
			this.uploadCancelled = true;

			// Clear progress interval
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
				this.progressInterval = null;
			}

			// Clean data and hide overlay
			this.cleanData();
		},
		cleanData() {
			this.fileName = this.$t("UploadFiles.SelectFile");
			this.dataFile = null;
			this.$emit("dataFileEmit", this.dataFile);
			this.textStatus = "";
			this.progressColor = "primary";
			this.status = null;
			this.uploadProgress = 0;
			this.is_indeterminate = false;
			this.showProgressOverlay = false;
			this.uploadCancelled = false;
			this.showSuccessState = false;
			this.showRedirectingState = false;
			this.uploadStartTime = null;

			// Clear progress interval
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
				this.progressInterval = null;
			}
		},
		handleMaximizeUploadFile() {
			this.maximize = !this.maximize;
		},
		dragover(event) {
			event.preventDefault();
			// Add some visual fluff to show the user can drop its files
			if (!event.currentTarget.classList.contains("bg-success--transparent")) {
				event.currentTarget.classList.remove("bg-gray");
				event.currentTarget.classList.add("bg-success--transparent");
			}
			this.isDragging = true;
		},
		dragleave(event) {
			// Clean up
			event.currentTarget.classList.add("bg-gray");
			event.currentTarget.classList.remove("bg-success--transparent");
			this.isDragging = false;
		},
		drop(event) {
			event.preventDefault();
			this.onFileChange(event); // Trigger the onChange event manually
			// Clean up
			event.currentTarget.classList.add("bg-gray");
			event.currentTarget.classList.remove("bg-success--transparent");
			this.isDragging = false;
		},
		addUploadFileVisitPoint() {
			let pickupsObject = {};
			let deliveryObject = {};
			if (this.getCheckedVisitPointsPickupUploadFile.length > 0)
				pickupsObject["file_visit_point"] = this.getCheckedVisitPointsPickupUploadFile.map((data) => {
					delete data.isDelivery;
					delete data.isPickup;
					return data;
				});
			if (this.getCheckedVisitPointsDeliveryUploadFile.length > 0)
				deliveryObject["file_visit_point"] = this.getCheckedVisitPointsDeliveryUploadFile.map((data) => {
					delete data.isDelivery;
					delete data.isPickup;
					return data;
				});
			const payload = {
				pickups: pickupsObject,
				deliveries: deliveryObject,
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					// Check if there are discarded items due to frequencies
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					if (this.getCheckedVisitPointsPickupUploadFile.length > 0)
						this.standardInput.pickups.push(...res.data.pickups);
					if (this.getCheckedVisitPointsDeliveryUploadFile.length > 0)
						this.standardInput.deliveries.push(...res.data.deliveries);
					this.$vs.loading.close();
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP");
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINTS_OPTIMIZATION");
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY");
					this.$emit("closePopupUploadFileEmit");
					this.$vs.notify({
						color: "success",
						title: this.$t("UploadFiles.UploadFiles"),
						text: this.$t("VisitingPointsWereSuccessfullyAdded"),
					});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
						time: 7000,
					});
					console.error(err);
					return err;
				});
		},
		addUploadFileVehicle() {
			let vehicleList = {};
			const payload = {};
			if (this.getCheckedVehicleUploadFile.length > 0)
				vehicleList["file_vehicle"] = this.getCheckedVehicleUploadFile;
			if (Object.entries(vehicleList).length > 0) payload.vehicles = vehicleList;
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					// Check if there are discarded items due to frequencies
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					this.standardInput.vehicles.push(...res.data.vehicles);
					this.$vs.loading.close();
					this.$store.commit("vehicle/REMOVE_ALL_UPLOAD_FILE_VEHICLE");
					this.$store.commit("vehicle/REMOVE_ALL_CHECKED_UPLOAD_FILE_VEHICLE");
					this.$emit("closePopupUploadFileEmit");
					this.$vs.notify({
						color: "success",
						title: this.$t("UploadFiles.UploadFiles"),
						text: this.$t("VehiclesWereSuccessfullyAdded"),
					});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
						time: 7000,
					});
					console.error(err);
					return err;
				});
		},
		addUploadFileJob() {
			const payload = {};
			const jobFiles = this.getJobsUploadFileList;
			if (jobFiles.length > 0) {
				payload.jobs = {
					file_jobs: jobFiles.map((data) => ({
						bucket_path: data.bucket_path,
						equivalent_fields: data.equivalent_fields,
					})),
				};
			}
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					if (res.data && res.data.jobs && res.data.jobs.length > 0) {
						this.$store.commit("moduleOptimization/SET_JOB_STANDARD_INPUT", res.data.jobs);
					}
					this.$vs.loading.close();
					this.$store.commit("moduleOptimization/REMOVE_ALL_UPLOAD_FILE_JOB");
					this.$store.commit("moduleOptimization/REMOVE_ALL_CHECKED_UPLOAD_FILE_JOB");
					this.$emit("closePopupUploadFileEmit");
					this.$vs.notify({
						color: "success",
						title: this.$t("UploadFiles.UploadFiles"),
						text: this.$t("Jobs.JobsWereSuccessfullyAdded"),
					});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
						time: 7000,
					});
					console.error(err);
					return err;
				});
		},
		showDiscardedItemsPrompt(discardedItems) {
			// Parse and translate the discarded items
			const translatedItems = discardedItems.map((item) => {
				// Parse the item string: "TYPE identifier, discarded due to frequencies."
				const parts = item.split(",");
				if (parts.length >= 2) {
					const typeAndIdentifier = parts[0].trim();
					// Split type and identifier
					const spaceIndex = typeAndIdentifier.indexOf(" ");
					if (spaceIndex !== -1) {
						const type = typeAndIdentifier.substring(0, spaceIndex).trim();
						const identifier = typeAndIdentifier.substring(spaceIndex + 1).trim();
						// Translate the type
						let translatedType = type;
						if (type === "PICKUP") {
							translatedType = this.$t("Frequency.DiscardedItems.Pickup");
						} else if (type === "DELIVERY") {
							translatedType = this.$t("Frequency.DiscardedItems.Delivery");
						} else if (type === "VEHICLE") {
							translatedType = this.$t("Frequency.DiscardedItems.Vehicle");
						}
						return `${translatedType} ${identifier}`;
					}
				}
				return item; // Return original if parsing fails
			});

			// Store the translated items and activate the prompt
			this.discardedItemsList = translatedItems;
			this.currentDiscardedItemsPage = 1; // Reset to first page
			this.activeDiscardedItemsPrompt = true;
		},
		// Pagination methods for discarded items
		changeDiscardedItemsPage(page) {
			if (page >= 1 && page <= this.totalDiscardedItemsPages) {
				this.currentDiscardedItemsPage = page;
			}
		},
		closeDiscardedItemsPrompt() {
			this.activeDiscardedItemsPrompt = false;
			this.currentDiscardedItemsPage = 1;
		},
		downloadJobTemplate() {
			try {
				downloadJobUploadTemplate(this.$t("Jobs.TemplateFileName"));
				this.$vs.notify({
					color: "success",
					title: this.$t("Success"),
					text: this.$t("Jobs.TemplateDownloadSuccess"),
				});
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					color: "danger",
					title: this.$t("Error"),
					text: this.$t("UploadFiles.DownloadFailedText"),
				});
			}
		},
	},
	created() {
		this.uploadProgress = 0;
	},
	beforeDestroy() {
		this.cleanData();
	},
};
